<template>
    <div class="cardInfoWrap">
        <div class="cardInfoHeader">
            <img @click="goBack" src="../assets/left.png" alt="">
            详情
        </div>
        <div class="cardInfoCon">
            <h2>商品详情</h2>
            <img class="shopDetail" :src="swiperpic.picUrl" alt="">
            <h3>商品名称：{{dataInfo.itemName}}</h3>
            <h3>有效期：{{dataInfo.expireDate}}</h3>
            <div class="tiaoXing">
                <p>提货券</p>
                <img class="statusImg" v-if="status==3" src="../assets/userOut.png" alt="">
                <img id='barcode' src="" alt="">
            </div>
            <h3>使用说明</h3>
            <p>
                <span>
                    1、山东移动尊享会员在线完成订单支付后，可在“我的”-“我的订单”-“额度购”中查看购买的卡券；
                </span>
                <span>
                    2、用户持卡券详情中的“条形码”前往山东省内中石化便利店领取商品
                </span>
            </p>
            <h3>客服电话：</h3>
            <p>
                售后问题请致电400-966-9058
            </p>
        </div>
    </div>
</template>
<script>
import JsBarcode from 'jsbarcode';
export default {
    data() {
        return {
            token: '',
            orderNo: '',
            dataInfo: {},
            swiperpic: {},
            status: ''
        }
    },
    mounted() {
        this.orderNo =  this.$route.query.orderNo
        this.token =  this.$route.query.token
        this.status =  this.$route.query.status
        this.init()
        //条形码
        
    },
    methods: {
        init() {
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/sdorder/getOrderDetailInfo?orderNo='+ this.orderNo,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token
                },
            }).then(res => {
                this.dataInfo = res.data.result
                this.swiperpic = this.dataInfo.swiperpic
                JsBarcode('#barcode', this.dataInfo.code, {
                    format: "CODE128",  //条形码的格式
                    lineColor: "#333",  //线条颜色
                    width:2, //线宽
                    height:60,  //条码高度
                    background: 'rgba(255,255,255,1)',
                    displayValue: true //是否显示文字信息
                });
            }).catch(e => {
                console.log(e);
            });
        },
        //返回
        goBack() {
            history.go(-1)
        }
    }
}
</script>
<style lang="sass" scoped>
.cardInfoWrap
    width: 100%;
    height: 100vh;
    display: flex;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #fff;
    .cardInfoHeader
        width: 100%;
        height: 0.4rem;
        background: #6A7D8F;
        text-align: center;
        line-height: 0.4rem;
        font-size: 0.15rem;
        color: #fff;
        position: relative;
        img
            width: 0.2rem;
            height: 0.2rem;
            position: absolute;
            top: 50%;
            left: 0.1rem;
            transform: translate(0, -50%);
    .cardInfoCon
        flex: 1;
        width: 100%;
        padding: 0.1rem 0.2rem 0 0.2rem;
        overflow: auto;
        >h2
            font-size: 0.16rem;
            font-weight: bolder;
        .shopDetail
            width: 100%;
            height: auto;
            display: block;
            margin-top: 0.1rem;
            margin-bottom: 0.1rem;
        >h3
            width: 100%;
            font-size: 0.15rem;
            font-weight: bolder;
            color: #333;
            line-height: 0.3rem;
        >p
            width: 100%;
            font-size: 0.13rem;
            line-height: 0.2rem;
            span
                display: block;
                margin-top: 0.05rem;
        .tiaoXing
            width: 100%;
            height: auto;
            display: block;
            position: relative;
            .statusImg
                width: 1rem;
                position: absolute;
                right: 0.04rem;
                top: -0.07em
            >img
                width: 90%;
                height: auto;
                margin: 0 auto;
                display: block;
            >p
                text-align: center;
                line-height: 0.3rem;
                font-size: 0.17rem;
                font-weight: bolder;
</style>


// WEBPACK FOOTER //
// src/page/cardInfo.vue